/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import Link from 'next/link';
import _ from 'lodash';
import moment from 'moment';

import { withTranslation } from 'language/i18n';
import { getObjectByLanguage } from 'language/helpers';
import maskAmount from 'utils/maskAmount';
import types from 'constants/types';
import { getCurrency } from 'models/payment';
import useTimerHandler from 'pages/machinery/hooks/useTimerHandler';
import { MACHINE_STATE } from 'constants/common';

const MachineryListItem = ({ t, machine }) => {
  const { timeLeft } = useTimerHandler({ machine, calculateStartingDateIfFutureEvent: true });

  const [currency, setCurrency] = useState(0);

  useEffect(() => {
    currencyEuroFromTl();
  }, []);

  const currencyEuroFromTl = async () => {
    const approxValue = await getCurrency(machine.auctionStartPrice);
    setCurrency(approxValue);
  };

  const handleHeadColor = () => {
    if (machine.state === MACHINE_STATE.SOLD || machine.state === MACHINE_STATE.SUSPENDED) {
      return 'gray';
    }
    if (moment().isSameOrBefore(machine.event.startDate)) {
      return 'gray';
    }
    if (timeLeft?.days > 1) {
      return 'green';
    }
    return 'red';
  };

  return (
    <Link href="/machinery/[id]" as={`/machinery/${machine.id}`}>
      <div className="im-box im-box--white im-box--hover im-box--border-radius im-box--list-item p-3 p-lg-4" style={{ cursor: 'pointer' }}>
        <div className="row">
          <div className="col-15 col-lg-3 mb-3 mb-lg-0">
            <div
              className="thumbnail-container thumbnail-container__w100 thumbnail-container--radius thumbnail-container--w-100 thumbnail-container--h-160"
            >
              <Image
                src={machine.coverImage || '/image/machine-detail-slider-placeholder.jpg'}
                layout="fill"
                objectFit="cover"
              />

              {/* <!-- TIME --> */}
              {
                machine.state === MACHINE_STATE.SOLD || machine.state === MACHINE_STATE.SUSPENDED
                  ? (
                    <div className={`thumbnail-container__title thumbnail-container__title--${handleHeadColor()}`}>
                      {types[machine.state]}
                    </div>
                  )
                  : !_.isEmpty(timeLeft)
                    && (
                      <div className={`thumbnail-container__title thumbnail-container__title--${handleHeadColor()}`}>
                        {
                          _.result(timeLeft, 'days') !== undefined && timeLeft.days > 0
                          && (
                            <span className="mr-1">
                              <span className="fw-900">{timeLeft.days < 10 ? `0${timeLeft.days}` : timeLeft.days}</span>
                              <span className="fs-10 fw-500">GÜN</span>
                            </span>
                          )
                        }
                        {
                          _.result(timeLeft, 'hours') !== undefined
                          && (
                            <span className="mr-1">
                              <span className="fw-900">{timeLeft.hours < 10 ? `0${timeLeft.hours}` : timeLeft.hours}</span>
                              <span className="fs-10 fw-500">SA</span>
                            </span>
                          )
                        }
                        {
                          _.result(timeLeft, 'minutes') !== undefined
                          && (
                            <span className="mr-1">
                              <span className="fw-900">{timeLeft.minutes < 10 ? `0${timeLeft.minutes}` : timeLeft.minutes}</span>
                              <span className="fs-10 fw-500">DK</span>
                            </span>
                          )
                        }
                        {
                          _.result(timeLeft, 'seconds') !== undefined
                          && (
                            <span className="mr-1">
                              <span className="fw-900">{timeLeft.seconds < 10 ? `0${timeLeft.seconds}` : timeLeft.seconds}</span>
                              <span className="fs-10 fw-500">SN</span>
                            </span>
                          )
                        }
                      </div>
                    )
              }
            </div>
          </div>
          <div className="col-15 col-lg">
            <div className="row h-100 flex-column">
              <div className="col">
                <div className="row">
                  <div className="col-15 col-sm-15 col-xl-10">
                    <div className="fs-18 fw-900 mb-3">
                      {getObjectByLanguage(machine.title)}
                    </div>
                    <p className="fs-14 text-gray3 mb-3">
                      {getObjectByLanguage(machine.summary)}
                    </p>
                  </div>
                  <div className="col-15 col-sm-15 col-xl-5">
                    <div className="row align-items-center mb-2">
                      <div className="col-auto col-sm-2 col-xl-5">
                        <Image
                          src="/temp/expertise-stamp.svg"
                          width="34"
                          height="34"
                        />
                      </div>
                      <div className="col col-sm-10">
                        <div className="fs-12 text-gray3 lh-1p4">
                          <span className="fw-700">
                            {'iyiMakina.com '}
                          </span>
                          tarafından incelendi.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-auto mt-1">
                <div className="row mb-2">
                  <div className="col-15 mb-2 mb-sm-0 col-sm-auto">
                    <div className="row flex-sm-column">
                      <div className="col col-sm-15 order-2 order-sm-1">
                        <span className="fs-14 fw-900 text-gray10 mb-1">{machine.machineId}</span>
                      </div>
                      <div className="col-6 col-sm-15 order-1 order-sm-2">
                        <span className="fs-14">{t('machineNo')}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-15 mb-2 mb-sm-0 col-sm-auto">
                    <div className="row flex-sm-column">
                      <div className="col col-sm-15 order-2 order-sm-1">
                        <span className="fs-14 fw-900 text-gray10 mb-1">{machine.workingHours}</span>
                      </div>
                      <div className="col-6 col-sm-15 order-1 order-sm-2">
                        <span className="fs-14">{t('workingHours')}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-15 mb-2 mb-sm-0 col-sm-auto">
                    <div className="row flex-sm-column">
                      <div className="col col-sm-15 order-2 order-sm-1">
                        <span className="fs-14 fw-900 text-gray10 mb-1">
                          {`${machine.region}, ${getObjectByLanguage(machine.country.name)}`}
                        </span>
                      </div>
                      <div className="col-6 col-sm-15 order-1 order-sm-2">
                        <span className="fs-14">{t('locationDif')}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-15 mb-2 mb-sm-0 col-sm-auto">
                    <div className="row flex-sm-column">
                      <div className="col col-sm-15 order-2 order-sm-1">
                        <span className="fs-14 fw-900 text-gray10 mb-1">{types[machine.event.type]}</span>
                      </div>
                      <div className="col-6 col-sm-15 order-1 order-sm-2">
                        <span className="fs-14">{t('saleType')}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-15 col-lg-4 ml-auto position-relative align-items-center">
            <div
              className="separator separator--vertical separator--absolute separator--mh-auto separator--absolute-rem-padding d-none d-lg-flex"
            />
            <div className="row h-100 align-items-center mb-3 mb-lg-0">
              <div className="col-15 pl-lg-4">
                <div className="text-center">
                  <div className="fs-35 fw-900 mb-1">{maskAmount(machine.auctionStartPrice)}</div>
                  <div className="fs-14 lh-1p4">Başlangıç Fiyatı</div>
                  <div className="fs-14 text-gray10">
                    {`(${t('approx')} ${maskAmount(currency, 'TRY')})`}
                  </div>
                </div>
                <a
                  className="im-button im-button--primary im-button--fluid im-button--center im-button--size-40 mt-5"
                >
                  {t('goToDetails')}
                </a>
              </div>
            </div>
          </div>
        </div>
        {/*  <a className="im-box__link" >link</a> */}
      </div>
    </Link>
  );
};

MachineryListItem.propTypes = {
  t: PropTypes.func,
  machine: PropTypes.object,
};

export default withTranslation('common')(MachineryListItem);
